import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { AssetType } from '@hub-la/fe-asset';
import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client';
import { inject } from 'inversify';

let GetPdfFileUrl = class GetPdfFileUrl {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(asset) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (((_a = asset === null || asset === void 0 ? void 0 : asset.url) === null || _a === void 0 ? void 0 : _a.includes('/download')) && asset.type === AssetType.application) {
        const file = yield this.getAssetFileBuffer(asset);
        return this.toObjectUrl(file);
      }
      return asset === null || asset === void 0 ? void 0 : asset.url;
    });
  }
  getAssetFileBuffer(asset) {
    return __awaiter(this, void 0, void 0, function* () {
      if (asset.url) {
        const response = yield this.httpClient.request({
          url: asset.url,
          method: HttpMethod.GET,
          responseType: 'arraybuffer'
        });
        if (response.statusCode === HttpStatusCode.OK) {
          return response.data;
        }
        throw new Error();
      }
    });
  }
  toObjectUrl(buffer) {
    const file = new Blob([buffer], {
      type: 'application/pdf'
    });
    const fileURL = URL.createObjectURL(file);
    return fileURL;
  }
};
GetPdfFileUrl = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], GetPdfFileUrl);

export { GetPdfFileUrl };
